// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"d0e93b3f0a02ed5ebba4","691":"bc6b30a1da4eb1b61fbb"}[chunkId] + ".js";
};